export default __webpack_public_path__ + "static/media/trailblazehers.1f510466.png";